// @flow
import { fetchSellersIfNeeded, getSeller } from './seller';
import { fetchCatalogBiddingIfNeeded } from './catalogBiddingInfo';
import { fetchCoverLotsIfNeeded } from './coverLots';
import { fetchSellerEndedCatalogsIfNeeded } from './sellerEndedCatalogs';
import { fetchSellerPreviewCatalogsIfNeeded } from './sellerPreviewCatalogs';
import { fetchSellerRecordResultsIfNeeded } from './sellerRecordResults';
import { fetchSellersDetailsIfNeeded } from './sellerDetail';
import { fetchSellerUpcomingCatalogsIfNeeded } from './sellerUpcomingCatalogs';
import { getNotFoundUrl } from '../../utils/urls';
import { getSellerCatalogs } from './filteredItems';
import { push } from 'connected-react-router';

export const fetchDataForSellerPage = (sellerId: number) => async (dispatch: Function, getState: Function) => {
    const promises = [
        dispatch(fetchSellersIfNeeded([sellerId])),
        dispatch(fetchSellersDetailsIfNeeded([sellerId])),
        dispatch(fetchSellerPreviewCatalogsIfNeeded(sellerId)),
    ];

    return Promise.all(promises).then(() => {
        const seller = getSeller(getState(), sellerId);
        if (!seller || !seller.sellerId) {
            return Promise.all([dispatch(push(getNotFoundUrl()))]);
        }
        return Promise.resolve();
    });
};

export const fetchDataForSellerPageUpcoming = (sellerId: number) => async (dispatch: Function, getState: Function) => {
    return Promise.all([dispatch(fetchSellerUpcomingCatalogsIfNeeded(sellerId))]).then(() => {
        const state = getState();

        const { items: upcomingCatalogs } = getSellerCatalogs(state, sellerId, {
            count: 'all',
            page: 1,
            sort: 'DATE_ASCENDING',
            tab: 'upcoming',
        });
        const upcomingCatalogIds = upcomingCatalogs.map(catalog => catalog.catalog.catalogId);

        const promises = [];
        promises.push(dispatch(fetchCoverLotsIfNeeded(upcomingCatalogIds)));
        promises.push(dispatch(fetchCatalogBiddingIfNeeded(upcomingCatalogIds)));

        return Promise.all(promises);
    });
};

export const fetchDataForSellerPagePast = (
    sellerId: number,
    page: number,
    count: number,
    searchTerms: string,
    sort: string
) => async (dispatch: Function, getState: Function) => {
    return Promise.all([dispatch(fetchSellerEndedCatalogsIfNeeded(sellerId, page, count, sort))]).then(() => {
        const newState = getState();
        const { items } = getSellerCatalogs(newState, sellerId, {
            count,
            page,
            sort,
            tab: 'ended',
            terms: searchTerms,
        });
        const ids = items.map(cat => cat.catalog.catalogId);
        return dispatch(fetchCoverLotsIfNeeded(ids));
    });
};

export const fetchDataForSellerPageRecordResults = (sellerId: number) => async (
    dispatch: Function,
    getState: Function
) => {
    return Promise.all([dispatch(fetchSellerRecordResultsIfNeeded(sellerId))]);
};
